"use client";

import { useTranslation } from "react-i18next";

const policyKeys = [
  { heading: "infoWeCollect", body: "infoWeCollectContent" },
  { heading: "howWeUse", body: "howWeUseContent" },
  { heading: "sharing", body: "sharingContent" },
  { heading: "retention", body: "retentionContent" },
  { heading: "yourRights", body: "yourRightsContent" },
] as const;

export default function PrivacyPolicyPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background">
      <section className="bg-primary py-10 text-white sm:py-14 md:py-16">
        <div className="mx-auto flex w-full max-w-4xl flex-col gap-3 px-4 sm:gap-4 sm:px-6">
          <h1 className="text-2xl font-black tracking-tight sm:text-3xl md:text-4xl">
            {t("privacy.title")}
          </h1>
          <p className="text-base text-white/90 sm:text-lg">{t("privacy.subtitle")}</p>
        </div>
      </section>
      <section className="py-10 sm:py-14 md:py-16">
        <div className="mx-auto w-full max-w-4xl space-y-6 px-4 text-slate-700 sm:space-y-8 sm:px-6">
          {policyKeys.map(({ heading, body }) => (
            <div key={heading} className="space-y-3">
              <h2 className="text-base font-semibold text-slate-900 sm:text-xl">
                {t(`privacy.${heading}`)}
              </h2>
              <p className="text-sm leading-6">{t(`privacy.${body}`)}</p>
            </div>
          ))}
          <div className="min-w-0 overflow-hidden rounded-2xl border border-border-soft bg-primary-soft px-4 py-4 text-sm text-primary-strong sm:rounded-3xl sm:px-6 sm:py-5">
            {t("privacy.questions")}{" "}
            <a className="font-semibold" href="mailto:privacy@bigsport.io">
              privacy@bigsport.io
            </a>
            .
          </div>
        </div>
      </section>
    </div>
  );
}
